export const MARKINGS = ['Partially Met', 'Achieving', 'High Performing', 'Exceeding'];
export const POSITIONS = [
  '9 Inconsistent',
  '8 Effective',
  '7 Early Promise',
  '6 Expert',
  '5 Good',
  '4 Strong',
  '3 High Potential',
  '2 Excellent',
  '1 Star',
];

const DARK_GREEN = '#176B3A';
const MARKING_COLOURS = ['#C43C39', '#E99A28', '#68A84F', DARK_GREEN];
const POSITION_COLOURS = [
  '#B52F35',
  '#CF5140',
  '#DF7533',
  '#E99A28',
  '#C5AE35',
  '#98AF40',
  '#68A84F',
  '#39854A',
  DARK_GREEN,
];

export default function ModerationDistribution({
  title,
  values,
  outcomes,
  selectedOutcome,
}: {
  title: string;
  values: string[];
  outcomes: string[];
  selectedOutcome?: string;
}) {
  const rated = values.map((value) => (outcomes.includes(value) ? value : 'Not provided'));
  const segments = [...outcomes, 'Not provided']
    .map((label, index) => ({
      label,
      count: rated.filter((value) => value === label).length,
      colour:
        label === 'Not provided'
          ? '#b1b4b6'
          : (outcomes.length === MARKINGS.length ? MARKING_COLOURS : POSITION_COLOURS)[index],
    }))
    .filter(({ count }) => count > 0);
  return (
    <section className="scs-moderation-distribution" aria-label={title}>
      <h2 className="govuk-heading-s">{title}</h2>
      {rated.length ? (
        <>
          <div className="scs-moderation-distribution__bar">
            {segments.map(({ label, count, colour }) => {
              const percentage = (count * 100) / rated.length;
              const text = `${Number(percentage.toFixed(1))}%`;
              return (
                <div
                  key={label}
                  className={`scs-moderation-distribution__segment${selectedOutcome === label ? ' is-selected' : ''}`}
                  style={{
                    flexBasis: `${percentage}%`,
                    backgroundColor: colour,
                    color: ['#C43C39', '#B52F35', DARK_GREEN].includes(colour)
                      ? '#ffffff'
                      : '#000000',
                  }}
                  title={`${label}: ${text} (${count})`}
                  aria-label={`${label}: ${text} (${count})${selectedOutcome === label ? ', selected filter' : ''}`}
                >
                  <span
                    aria-hidden="true"
                    style={percentage < 6 ? { writingMode: 'vertical-rl' } : undefined}
                  >
                    {text}
                  </span>
                </div>
              );
            })}
          </div>
          <ul className="scs-moderation-distribution__legend govuk-list">
            {segments.map(({ label, count, colour }) => (
              <li key={label} className={selectedOutcome === label ? 'is-selected' : undefined}>
                <span style={{ backgroundColor: colour }} aria-hidden="true" />
                {label} ({count}){selectedOutcome === label && ' - selected'}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className="govuk-body">No ratings set yet.</p>
      )}
    </section>
  );
}
